import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidebarState {
  isMobileMenuOpen: boolean;
  isCollapsed: boolean;
}

const initialState: SidebarState = {
  isMobileMenuOpen: false,
  isCollapsed: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar(state) {
      if (window.innerWidth < 768) {
        state.isMobileMenuOpen = !state.isMobileMenuOpen;
      } else {
        state.isCollapsed = !state.isCollapsed;
      }
    },
    setMobileMenuOpen(state, action: PayloadAction<boolean>) {
      state.isMobileMenuOpen = action.payload;
    },
    setCollapsed(state, action: PayloadAction<boolean>) {
      state.isCollapsed = action.payload;
    },
  },
});

export const { toggleSidebar, setMobileMenuOpen, setCollapsed } = sidebarSlice.actions;
export default sidebarSlice.reducer;
